<template>
  <div class="container v-content-container">
    <div class="row">
      <div class="col-xs-12">
        <h1>
          <i class="fa fa-fw fa-lg fa-cog"></i
          >{{
            `${$label("venue.venue", "Venue")}${
              noDataExist ? "" : ": " + venueName
            }`
          }}
          <router-link
            class="btn btn-v-lightgreen-white pull-right"
            :to="{
              name: 'NewVenuePrice',
              params: { id: selectedVenueId, price_type: 'default' }
            }"
            v-tooltip="{
              content: $label('venue.create_new_price', 'Create new price'),
              classes: 'custom-tooltip'
            }"
          >
            <i class="fa fa-fw fa-lg fa-plus"></i>
          </router-link>
          <select
            v-model="selectedVenueId"
            class="form-control venue-select pull-right"
            style="margin-right: 15px;"
          >
            <optgroup
              v-for="facility in facilities"
              :label="facility.name"
              v-bind:key="facility.id"
            >
              <option
                v-for="venue in facility.venues"
                :value="venue.id"
                v-bind:key="venue.id"
                >{{ venue.name }}</option
              >
            </optgroup>
          </select>
        </h1>
      </div>
    </div>

    <navigation-tabs :venue-id="selectedVenueId"></navigation-tabs>

    <div class="row mt-8">
      <div class="col-xs-12">&nbsp;</div>
    </div>

    <error404 v-if="noDataExist" />

    <template v-else>
      <div class="row mt-8">
        <div class="col-sm-12 activate-price-alert">
          <div class="v-form-partial">
            <div class="v-form">
              <fieldset>
                <section>
                  <i class="text-primary fa fa-fw fa-lg fa-info-circle"></i>
                  {{
                    $label(
                      "venue.automatic_price_calculation",
                      "Automatic price calculation:"
                    )
                  }}
                  <a class="ml-2" data-toggle="lightbox" href="#lbPriceCalc"
                    >&nbsp;Expiry</a
                  >
                  <a class="ml-2" data-toggle="lightbox" href="#lbPrices"
                    >&nbsp;Price types</a
                  >
                </section>
              </fieldset>
            </div>
          </div>
        </div>
      </div>

      <hr />

      <div class="row mt-8">
        <div class="col-xs-12">&nbsp;</div>
      </div>

      <alert-box
        v-show="failedRequest"
        type="warning"
        :closeable="false"
        :show-icon="false"
      >
        {{
          $label(
            "venue.venue_failed_request",
            "Request failed while loading venue prices."
          )
        }}
      </alert-box>
      <Table
        v-show="!failedRequest"
        id="venue-prices-table"
        :loading="loading"
        :columns="[
          {
            title: 'Type',
            field: 'type',
            id: row => `price-type-${row.id}`
          },
          {
            title: 'Gross',
            value: row => `${row.amount_gross} EUR / h`,
            id: row => `price-gross-${row.id}`
          },
          {
            title: 'VAT',
            value: row => `${row.vat.name}`,
            id: row => `price-vat-${row.id}`
          },
          {
            title: 'designation',
            field: 'name',
            id: row => `price-name-${row.id}`
          },
          {
            title: 'date',
            value: row => '-',
            id: row => `price-date-${row.id}`
          },
          {
            title: 'time',
            value: row => '-',
            id: row => `price-time-${row.id}`
          }
        ]"
        :actions="[
          {
            type: 'detail',
            disabled: row => row.type !== 'default',
            onClick: row => {
              $router.push({
                name: 'VenuePriceDetails',
                params: { id: selectedVenueId, price_id: row.id }
              });
            }
          },
          {
            type: 'delete',
            id: row => `delete-price-button-${row.id}`,
            onClick: row => deleteVenuePrice(row.id)
          }
        ]"
        :data="venuePrices"
        :meta="metaData"
        @fetchQuery="
          params => {
            fetchParams = params;
            getVenuePrices({
              //
            });
          }
        "
      >
        <div
          id="action-dropdown"
          slot="toolbar"
          class="btn-group"
          style="margin-left: 5px;"
        >
          <button
            type="button"
            class="btn btn-primary dropdown-toggle"
            data-toggle="dropdown"
            @click="toggleDropdown"
            @blur="closeDropdown"
          >
            <i class="fa fa-refresh"></i> &nbsp;
            {{ $label("common.actions", "Actions") }} &nbsp;<span
              class="caret"
            ></span>
          </button>
          <ul
            class="dropdown-menu"
            :class="{
              show: showDropdown
            }"
            role="menu"
          >
            <li>
              <router-link
                :to="{
                  name: 'NewVenuePrice',
                  params: { id: selectedVenueId, price_type: 'default' }
                }"
                ><i class="text-primary fa fa-fw fa-lg fa-plus"></i>
                {{
                  $label("venue.create_default_price", "Standardpreis")
                }}</router-link
              >
            </li>
            <li>
              <router-link to=""
                ><i class="text-primary fa fa-fw fa-lg fa-plus"></i>
                Auswahlpreis</router-link
              >
            </li>
            <li>
              <router-link to=""
                ><i class="text-primary fa fa-fw fa-lg fa-plus"></i>
                Periodenpreis</router-link
              >
            </li>
            <li>
              <router-link to=""
                ><i class="text-primary fa fa-fw fa-lg fa-plus"></i>
                Gruppen-Periodenpreis</router-link
              >
            </li>
            <li>
              <router-link to=""
                ><i class="text-primary fa fa-fw fa-lg fa-plus"></i>
                Gruppenpreis</router-link
              >
            </li>
            <li>
              <router-link to=""
                ><i class="text-primary fa fa-fw fa-lg fa-plus"></i> Last
                Minute</router-link
              >
            </li>
            <li>
              <router-link to=""
                ><i class="text-primary fa fa-fw fa-lg fa-plus"></i>
                Pauschalpreis</router-link
              >
            </li>
            <li>
              <router-link to=""
                ><i class="text-primary fa fa-fw fa-lg fa-plus"></i>
                Tagespauschalpreis</router-link
              >
            </li>
            <li>
              <router-link to=""
                ><i class="text-primary fa fa-fw fa-lg fa-plus"></i>
                Stufenpreis
              </router-link>
            </li>
          </ul>
        </div>
      </Table>

      <div class="row mb-8">
        <div class="col-xs-12">&nbsp;</div>
      </div>
    </template>
  </div>
</template>

<script>
import Api from "@/api.js";
import swal from "sweetalert";
import FormErrorsMixin from "@/mixins/FormErrors";

import NavigationTabs from "@/components/Settings/Venue/NavigationTabs.vue";
import Table from "@/components/Common/Table";
import AlertBox from "@/components/Common/Alerts/AlertBox";
import Error404 from "@/components/Common/Error404";

export default {
  name: "VenuePrices.vue",

  mixins: [FormErrorsMixin],

  components: {
    Table,
    NavigationTabs,
    AlertBox,
    Error404
  },

  data() {
    return {
      venuePrices: [],
      facilities: [],
      loading: false,
      updating: false,
      noDataExist: false,
      defaultPrice: {
        type: "default",
        name: "Default",
        form: "gross",
        vat_id: 1,
        amount: 0
      },
      availableVats: null,
      failedRequest: false,
      metaData: null,
      fetchParams: {
        page: 1,
        per_page: null,
        search: ""
      },
      selectedVenue: null,
      selectedVenueId: null,
      componentKey: 0,
      validatedInputs: ["form", "vat", "amount"],
      showDropdown: false
    };
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.selectedVenueId = vm.$route.params.id;

      vm.getFacilities(() => {
        if (
          vm.selectedVenueId !== null &&
          vm.selectedVenueId !== undefined &&
          vm.selectedVenueId !== "default"
        ) {
          if (vm.$route.query.price_created) {
            swal("Success!", "The price was created.", "success").then(() => {
              window.history.pushState(
                {},
                document.title,
                window.location.pathname
              );
            });
          }
          vm.getVenue(() => {
            vm.getVenuePrices(() => {
              //
            });
          });
        }
      });
    });
  },

  beforeRouteUpdate(to, from, next) {
    if (to.query.venue_price_deleted === true) {
      swal("Success!", "The price was deleted.", "success").then(() => {
        window.history.pushState({}, document.title, window.location.pathname);
      });
    }
    this.forceRerender();
    if (
      this.fetchParams.to % this.fetchParams.per_page === 0 &&
      this.fetchParams.page !== 1
    ) {
      this.fetchParams.page -= 1;
    }
    this.getFacilities(() => {
      if (
        this.selectedVenueId !== null &&
        this.selectedVenueId !== undefined &&
        this.selectedVenueId !== "default"
      ) {
        this.getVenue(() => {
          this.getVenuePrices(() => {
            //
          });
        });
      }
    });
    next();
  },

  mounted() {
    //
  },

  methods: {
    getFacilities(successCallback) {
      const endpoint = this.$partnerEndpoint("facilities/simplified");

      Api()
        .get(endpoint)
        .then(response => {
          this.facilities = response.data.data;
          if (!this.selectedVenueId || this.selectedVenueId === "default") {
            const selectedFacility = this.facilities.find(
              facility => facility.venues.length > 0
            );
            if (selectedFacility) {
              this.selectedVenueId = selectedFacility.venues[0].id;
            }
          }
          if (typeof successCallback == "function") {
            successCallback();
          }
        })
        .catch(error => {
          console.log(error);
        });
    },

    getVenue(successCallback) {
      const endpoint = this.$partnerEndpoint("venues/" + this.selectedVenueId);

      Api()
        .get(endpoint)
        .then(response => {
          this.selectedVenue = response.data.data;
          if (typeof successCallback == "function") {
            successCallback();
          }
        })
        .catch(error => {
          if (error.response.status === 404) {
            this.noDataExist = true;
          }
          console.log(error.response);
        });
    },

    getVenuePrices(successCallback) {
      this.loading = true;
      this.venuePrices = [];
      const endpoint = this.$partnerEndpoint(
        "venues/" + this.selectedVenueId + "/prices"
      );

      Api()
        .get(endpoint, {
          params: {
            page: this.fetchParams.page,
            search: this.fetchParams.search
          }
        })
        .then(response => {
          this.venuePrices = response.data.data;
          this.metaData = response.data.meta;
          this.failedRequest = false;
          if (typeof successCallback == "function") {
            successCallback();
          }
        })
        .catch(() => {
          this.failedRequest = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    deleteVenuePrice(priceId) {
      if (this.loading || this.updating || priceId == null) {
        return;
      }

      swal({
        title: "Are you sure?",
        text: "The price will be deleted and will not be able to use it",
        icon: "warning",
        dangerMode: true,
        buttons: {
          cancel: {
            visible: true,
            text: "Cancel",
            closeModal: true
          },
          confirm: {
            visible: true,
            text: "Yes, delete it!",
            closeModal: true
          }
        }
      }).then(isConfirm => {
        if (isConfirm) {
          const endpoint = this.$partnerEndpoint("venue-prices/" + priceId);

          Api()
            .delete(endpoint)
            .then(() => {
              this.$router
                .push({
                  name: "VenuePrices",
                  query: { venue_price_deleted: true }
                })
                .catch(error => {
                  console.log(error);
                  if (
                    error.name === "NavigationDuplicated" ||
                    error.message.includes(
                      "Avoided redundant navigation to current location"
                    )
                  ) {
                    swal("Success!", "The price was deleted.", "success");
                    this.getVenuePrices(() => {
                      //
                    });
                  }
                });
            })
            .catch(error => {
              if (error.response.status === 403) {
                swal({
                  title: "Missing permission",
                  text: "You are not allowed to delete venue prices.",
                  icon: "error"
                  //dangerMode: true,
                });
              }
            });
        } else {
          //
        }
      });
    },

    forceRerender() {
      this.componentKey += 1;
    },

    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },

    closeDropdown(e) {
      if (!e.relatedTarget.pathname) this.showDropdown = false;
    }
  },

  computed: {
    venueName() {
      return this.selectedVenue ? this.selectedVenue.name : "";
    }
  },
  watch: {
    selectedVenueId(selectedVenueId) {
      this.$router.push({
        name: "VenuePrices",
        params: { id: selectedVenueId }
      });
    }
  }
};
</script>

<style scoped>
.mt-8 {
  margin-top: 1.3rem;
}

.mb-8 {
  margin-bottom: 1.3rem;
}

.ml-2 {
  margin-left: 0.6rem;
}

@media screen and (max-width: 600px) {
  .activate-price-alert {
    margin-top: 1.3rem;
  }
  .activate-price-alert > div {
    display: flex;
    text-align: center;
  }
}
</style>
